import React from 'react';
import { SimulationConfig } from '@/types';
import { SmartInput } from './SmartInput';
import { Sparkles } from 'lucide-react';
import { CollapsibleSection } from './CollapsibleSection';

interface GlobalVisualsSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
  isLocked?: boolean;
  minPlan?: string;
  onUpgradeClick?: () => void;
}

export const GlobalVisualsSection: React.FC<GlobalVisualsSectionProps> = ({ 
    config, setConfig, isLocked, minPlan = "PRO", onUpgradeClick 
}) => {
  return (
    <CollapsibleSection 
        title="Global Visuals" 
        icon={Sparkles} 
        darkMode={config.darkMode}
        settingKey="globalVisuals"
        isLocked={isLocked}
        lockRequiredPlan={minPlan as any}
        onUpgradeClick={onUpgradeClick}
    >
        <div className="flex flex-col gap-4 mt-6 text-left">
            <SmartInput label="Hue Cycle Velocity" settingKey="hueCycleSpeed" min={0} max={20} step={0.1} value={config.hueCycleSpeed} onChange={v => setConfig(p => ({...p, hueCycleSpeed: v}))} darkMode={config.darkMode} />
            <SmartInput label="Seismic Multiplier" settingKey="shakeIntensityMultiplier" min={0} max={5} step={0.1} value={config.shakeIntensityMultiplier} onChange={v => setConfig(p => ({...p, shakeIntensityMultiplier: v}))} darkMode={config.darkMode} />
            <SmartInput label="Seismic Decay" settingKey="shakeDecayRate" min={0.5} max={0.99} step={0.01} value={config.shakeDecayRate} onChange={v => setConfig(p => ({...p, shakeDecayRate: v}))} darkMode={config.darkMode} />
            <SmartInput label="Pop Decay Flow" settingKey="popDecayRate" min={0.01} max={0.5} step={0.01} value={config.popDecayRate} onChange={v => setConfig(p => ({...p, popDecayRate: v}))} darkMode={config.darkMode} />
        </div>
    </CollapsibleSection>
  );
};
